import { getAppName } from "../adapters/insights-agent/state/hooks/getAppName.ts";
import { getEnvironment } from "./getEnvironment.ts";
import { isCLA, isPLA } from "./FeatureFlagManager/hostnameCheckers.ts";

/**
 * @type ConfigType
 */
export const config = {
  appTitle: getAppName(isCLA(), isPLA()),
  environment: getEnvironment(),
  baseUrl: {
    dev: "https://agent.dev.ipsosfacto.com/knowledge-source-search-and-answers",
    beta: "https://agent.beta.ipsosfacto.com/knowledge-source-search-and-answers",
    prod: "https://agent.prod.ipsosfacto.com/knowledge-source-search-and-answers",
  },
  firebase: {
    dev: {
      // This API key is a public key and is not sensitive. https://firebase.google.com/docs/projects/api-keys
      apiKey: "AIzaSyAl8UPPkN4-HCGjaHdX7arB0IAQum2lk2U", // gitleaks:allow
      authDomain: "ipsosfacto-dev.firebaseapp.com",
      projectId: "ipsosfacto-dev",
      storageBucket: "ipsosfacto-dev.firebasestorage.app",
      messagingSenderId: "958506128989",
      appId: "1:958506128989:web:12fd0550ca69384e2a9fb4",
      measurementId: "G-PXKMMKCYHQ",
    },
    beta: {
      // This API key is a public key and is not sensitive. https://firebase.google.com/docs/projects/api-keys
      apiKey: "AIzaSyANQLpQVPcyBVeh8ObncanmuL80mzkvjR0", // gitleaks:allow
      authDomain: "ipsosfacto-beta.firebaseapp.com",
      projectId: "ipsosfacto-beta",
      storageBucket: "ipsosfacto-beta.firebasestorage.app",
      messagingSenderId: "635240276356",
      appId: "1:635240276356:web:e223bcb2e2a3d3c101bdd1",
      measurementId: "G-E8CC5R9RL8",
    },
    prod: {
      // This API key is a public key and is not sensitive. https://firebase.google.com/docs/projects/api-keys
      apiKey: "AIzaSyA_sJc0O2jtjtbiWzM_5xaluvYqWEv73PU", // gitleaks:allow
      authDomain: "ipsosfacto-prd.firebaseapp.com",
      projectId: "ipsosfacto-prd",
      storageBucket: "ipsosfacto-prd.firebasestorage.app",
      messagingSenderId: "744738540908",
      appId: "1:744738540908:web:d21655963269cf131cf749",
      measurementId: "G-MC193FT01P",
    },
  },
  microsoft: {
    clientId: "1092197f-937b-439b-a403-93295587e186",
  },
};
